import axios from "axios";
import { QueryBuilder } from "./queryBuilder";

export async function fetcher({
    url,
    method = "GET",
    params,
    data,
    query = {},
    baseURL,
    headers,
}) {
    /** Replace params in URL */
    for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            url = url.replace(`:${key}`, element);
        }
    }

    for (const key in query) {
        if (Object.hasOwnProperty.call(query, key)) {
            if (!query[key] || query[key] == "") {
                delete query[key];
            }
        }
    }

    let config = {
        url,
        method,
        params: query,
        data,
        headers,
    };

    if (baseURL) {
        config = {
            ...config,
            baseURL,
        };
    }

    try {
        const { data } = await axios(config);
        return data;
    } catch (error) {
        throw error;
    }
}

export function snakeToCamel(snakeCaseString) {
    return snakeCaseString.replace(/_([a-z0-9])/g, (_, letter) =>
        letter.toUpperCase()
    );
}

export function snakeToSpace(snakeCaseString) {
    return snakeCaseString.replace(
        /_([a-z0-9])/g,
        (_, letter) => " " + letter.toLowerCase()
    );
}

export function camelToSnake(camelCaseString) {
    return camelCaseString.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
}

export function generateShortUniqueId() {
    const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let id = "";
    for (let i = 0; i < 6; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
}

export function parseURL(url) {
    // Crear un objeto URL para analizar la URL
    const parsedUrl = new URL(url);

    // Obtener la base URL (protocolo + host)
    const baseURL = `${parsedUrl.protocol}//${parsedUrl.host}`;

    // Obtener el path (ruta)
    const path = parsedUrl.pathname;

    // Obtener los queryParams como un objeto
    const queryParams = {};
    parsedUrl.searchParams.forEach((value, key) => {
        queryParams[key] = value;
    });

    return {
        baseURL,
        path,
        queryParams,
    };
}

export function applyQueryToRoute({ route, query }) {
    const queryBuilder = new QueryBuilder(query);

    return route + "?query=" + queryBuilder.toString();
}

export function getValueByPath(obj, path) {
    if (!obj || typeof path !== "string") {
        return undefined;
    }

    const keys = path.split(".");
    let current = obj;

    for (const key of keys) {
        if (current[key] === undefined) {
            return undefined; // Devuelve undefined si alguna clave no existe
        }
        current = current[key];
    }

    return current;
}

export function setValueByPath(obj, path, value) {
    if (!obj || typeof path !== "string") {
        return undefined;
    }

    const keys = path.split("."); // Divide la ruta en partes
    let current = obj;

    // Navega por las claves excepto la última
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];

        // Crea un objeto vacío si no existe el nivel
        if (!(key in current) || typeof current[key] !== "object") {
            current[key] = {};
        }

        current = current[key];
    }

    // Asigna el valor a la última clave
    current[keys[keys.length - 1]] = value;
}

export const deepClone = function (obj) {
    if (Array.isArray(obj)) {
        return obj.map(deepClone);
    } else if (obj && typeof obj === "object") {
        var cloned = {};
        var keys = Object.keys(obj);
        for (var i = 0, l = keys.length; i < l; i++) {
            var key = keys[i];
            cloned[key] = deepClone(obj[key]);
        }
        return cloned;
    } else {
        return obj;
    }
};

export function showLineBreaksAsText(inputText) {
    if (typeof inputText !== "string") return "";

    // Replace actual line break characters with their visible escape sequences
    return inputText
        .replace(/\r\n/g, "\\r\\n") // Windows-style CRLF
        .replace(/\n\r/g, "\\n\\r") // Rare reversed case
        .replace(/\r/g, "\\r") // Old Mac CR
        .replace(/\n/g, "\\n"); // Unix/Linux LF
}
